<template>
  <el-row>
    <div class="row">
      <el-col v-if="selectedParams.objtypeId === 'VCL'" :md="24" :lg="24">
        <el-col :md="24" :lg="24">
          <table class="list-none-border">
            <tr v-if="configInfoData['VCL_COMMON/TEMPLATE_COUNT']">
              <th>호스트 / VM / 템플릿 수</th>
              <td>{{getEmptyText(configInfoData['VCL_COMMON/HOST_COUNT'])}} / {{getEmptyText(configInfoData['VCL_COMMON/VM_COUNT'])}}
                 / {{getEmptyText(configInfoData['VCL_COMMON/TEMPLATE_COUNT'])}}</td>
            </tr>
            <tr v-else>
              <th>호스트 / VM</th>
              <td>{{getEmptyText(configInfoData['VCL_COMMON/HOST_COUNT'])}} / {{getEmptyText(configInfoData['VCL_COMMON/VM_COUNT'])}}</td>
            </tr>
            <tr>
              <th>총 프로세서 수</th>
              <td>{{getEmptyText(configInfoData['VCL_COMMON/PROCESSOR_TOTAL_COUNT'])}}</td>
            </tr>
            <tr>
              <th>CPU 전체용량</th>
              <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VCL_CPU/TOTAL_CAPACITY']), 'MB', true, false, true))}}hz</td>
            </tr>
            <tr>
              <th>메모리 전체용량</th>
              <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VCL_MEM/TOTAL_CAPACITY']), 'MB', true, false, true))}}B</td>
            </tr>
            <tr>
              <th>스토리지 전체용량</th>
              <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VCL_STORAGE/TOTAL_CAPACITY']), 'MB', true, false, true))}}B</td>
            </tr>
          </table>
        </el-col>
      </el-col>

      <el-col v-if="selectedParams.objtypeId === 'VHO'" :md="24" :lg="24">
        <el-col :md="24" :lg="24">
          <table class="list-none-border">
            <tr>
              <th>IP</th>
              <td>{{getEmptyText(configInfoData['VHO_COMMON/IPADDRESS'])}}</td>
            </tr>
            <tr>
              <th>프로세스 유형</th>
              <td>{{getEmptyText(configInfoData['VHO_PROCESSOR/PROCESSOR_TYPE'])}}</td>
            </tr>
            <tr>
              <th>소켓 / 코어 / 메모리</th>
              <td>{{getEmptyText(configInfoData['VHO_PROCESSOR/PROCESSOR_SOCKET_COUNT'])}} / {{getEmptyText(configInfoData['VHO_PROCESSOR/CPU_CORES_PER_SOCKET'])}}
                 / {{getEmptyText(convertValuByUnit(Number(configInfoData['VHO_MEM/TOTAL_CAPACITY']), 'MB', true, false, true))}}B</td>
            </tr>
            <tr v-if="configInfoData['VHO_COMMON/TEMPLATE_COUNT']">
              <th>VM / 템플릿 수</th>
              <td>{{getEmptyText(configInfoData['VHO_COMMON/VM_COUNT'])}} / {{getEmptyText(configInfoData['VHO_COMMON/TEMPLATE_COUNT'])}}</td>
            </tr>
            <tr v-else>
              <th>VM 수</th>
              <td>{{getEmptyText(configInfoData['VHO_COMMON/VM_COUNT'])}}</td>
            </tr>
            <tr v-if="configInfoData['VHO_COMMON/BOOT_TIME']">
              <th>기동시각</th>
              <td>{{getEmptyText(configInfoData['VHO_COMMON/BOOT_TIME'])}} ( {{getEmptyText(configInfoData.periodBootTime)}} )</td>
            </tr>
          </table>
        </el-col>
      </el-col>

      <el-col v-if="selectedParams.objtypeId === 'VVM'" :md="24" :lg="24">
        <el-col :md="24" :lg="24">
          <table class="list-none-border">
            <tr>
              <th>운영상태</th>
              <td>{{getEmptyText(configInfoData['VVM_COMMON/ALIVE'])}}</td>
            </tr>
            <tr>
              <th>IP</th>
              <td>{{getEmptyText(configInfoData['VVM_COMMON/IPADDRESS'])}}</td>
            </tr>
            <tr>
              <th>VM 운영체제</th>
              <td>{{getEmptyText(configInfoData['VVM_COMMON/OS'])}}</td>
            </tr>
            <tr>
              <th>CPU / 메모리 용량</th>
              <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VVM_CPU/TOTAL_CAPACITY']), 'MB', true, false, true))}}hz
                 / {{getEmptyText(convertValuByUnit(Number(configInfoData['VVM_MEM/TOTAL_CAPACITY']), 'MB', true, false, true))}}B</td>
            </tr>
            <tr v-if="configInfoData['VVM_COMMON/BOOT_TIME']">
              <th>기동시각</th>
              <td>{{getEmptyText(configInfoData['VVM_COMMON/BOOT_TIME'])}}  ( {{getEmptyText(configInfoData.periodBootTime)}} )</td>
            </tr>
          </table>
        </el-col>
      </el-col>

      <el-col v-if="selectedParams.objtypeId === 'VDSC'" :md="24" :lg="24">
        <el-col :md="24" :lg="24">
          <table class="list-none-border">
            <tr>
              <th>스토리지 수</th>
              <td>{{getEmptyText(configInfoData['VDSC_COMMON/STORAGE_COUNT'])}}</td>
            </tr>
            <tr>
              <th>전체 용량</th>
              <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VDSC_STORAGE/TOTAL_CAPACITY']), 'MB', true, false, true))}}B</td>
            </tr>
            <tr>
              <th>VMDK / 스냅샷 수</th>
              <td>{{getEmptyText(configInfoData['VDSC_COMMON/VMDK_COUNT'])}} / {{getEmptyText(configInfoData['VDSC_COMMON/SNAPSHOT_COUNT'])}}</td>
            </tr>
            <tr>
              <th>유형</th>
              <td>{{getEmptyText(configInfoData['VDSC_COMMON/TYPE'])}}</td>
            </tr>
            <tr>
              <th>스토리지 DRS</th>
              <td>{{getEmptyText(configInfoData['VDSC_COMMON/DRS_MODE'])}}</td>
            </tr>
            <tr>
              <th>DRS 자동화 수준</th>
              <td>{{getEmptyText(configInfoData['VDSC_DRS/DRS_AUTO_LEVEL'])}}</td>
            </tr>
          </table>
        </el-col>
      </el-col>

      <el-col v-if="selectedParams.objtypeId === 'VDS'" :md="24" :lg="24">
          <el-col :md="24" :lg="24">
            <table class="list-none-border">
              <tr>
                <th>전체용량</th>
                <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VDS_STORAGE/TOTAL_CAPACITY']), 'MB', true, false, true))}}B</td>
              </tr>
              <tr v-if="configInfoData['VDS_COMMON/TEMPLATE_COUNT']">
                <th>호스트 / VM / 템플릿 수</th>
                <td>{{getEmptyText(configInfoData['VDS_COMMON/HOST_COUNT'])}} / {{getEmptyText(configInfoData['VDS_COMMON/VM_COUNT'])}} / {{getEmptyText(configInfoData['VDS_COMMON/TEMPLATE_COUNT'])}}</td>
              </tr>
              <tr v-else>
                <th>호스트 / VM</th>
                <td>{{getEmptyText(configInfoData['VDS_COMMON/HOST_COUNT'])}} / {{getEmptyText(configInfoData['VDS_COMMON/VM_COUNT'])}}</td>
              </tr>
              <tr v-if="configInfoData['VDS_COMMON/LOCATION']">
                <th>위치</th>
                <td>{{getEmptyText(configInfoData['VDS_COMMON/LOCATION'])}}</td>
              </tr>
              <tr>
                <th>파일시스템</th>
                <td>{{getEmptyText(configInfoData['VDS_COMMON/FILE_SYSTEM'])}}</td>
              </tr>
              <tr v-if="configInfoData['VDS_COMMON/BLOCK_SIZE']">
                <th>블록크기</th>
                <td>{{getEmptyText(convertValuByUnit(Number(configInfoData['VDS_COMMON/BLOCK_SIZE']), 'MB', true, false, true))}}</td>
              </tr>
            </table>
          </el-col>
      </el-col>
    </div>
  </el-row>
</template>

<script>
import WPerfWidget from '@/views/performance/node/summary/components/PerfWidget';
import perfApi from '@/api/virtual/performance/config';
import { calcUptime } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { isNil, isNaN } from 'lodash';
import { convertValuByUnit } from '@/utils/number';

export default {
  name: 'WVirtualMapInfoConfig',
  components: {
    WPerfWidget,
  },
  props: {
    selectedParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      configInfoData: {
        periodBootTime: '',
      },
    };
  },
  computed: {
    objtypeNameWidthTemplate() {
      if (this.configInfoData.vmTemplateFlag === '1') {
        return `${this.configInfoData.objtypeName} (템플릿)`;
      }
      return this.configInfoData.objtypeName;
    },
  },
  watch: {
    selectedParams: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
  },
  methods: {
    convertValuByUnit,
    loadData() {
      // 구성정보 조회
      perfApi.getNodeConfigInfoForObjtype({
        objId: this.selectedParams.objId,
        objtypeId: this.selectedParams.objtypeId,
      }).then((response) => {
        if (response.data.success) {
          this.configInfoData = response.data.data[0];
          if (this.selectedParams.objtypeId === 'VVM' && this.configInfoData['VVM_COMMON/BOOT_TIME'] !== '') {
            this.configInfoData.periodBootTime = calcUptime(new Date(this.configInfoData['VVM_COMMON/BOOT_TIME']), new Date());
          }
          if (this.selectedParams.objtypeId === 'VHO' && this.configInfoData['VHO_COMMON/BOOT_TIME'] !== '') {
            this.configInfoData.periodBootTime = calcUptime(new Date(this.configInfoData['VHO_COMMON/BOOT_TIME']), new Date());
          }
        }
      });
    },
    getEmptyText(value) {
      if (!isNaN(value) && !isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style scope>
  .list-none-border th {
    width: 142px;
  }
</style>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VirtualMapInfoConfig.vue